import { useState } from 'react'
import { Select as AntSelect } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { SelectProps, SelectValue } from 'antd/lib/select'

type IProps<T = SelectValue> = SelectProps<T> & {
  children: React.ReactNode
}

function Select<T = SelectValue>({
  mode,
  showSearch,
  value,
  onSelect,
  onDeselect,
  placeholder,
  notFoundContent,
  children,
  disabled,
  onDropdownVisibleChange,
  ...rest
}: IProps<T>) {
  const [selecting, setSelecting] = useState(false)

  return (
    <AntSelect
      showArrow
      style={{ width: '100%' }}
      mode={mode}
      showSearch={showSearch}
      value={value}
      placeholder={placeholder}
      menuItemSelectedIcon={<FontAwesomeIcon icon={faCheck as IconProp} />}
      suffixIcon={
        <FontAwesomeIcon
          icon={selecting ? faChevronUp : (faChevronDown as IconProp)}
        />
      }
      onDropdownVisibleChange={(open) => {
        setSelecting(open)
        onDropdownVisibleChange?.(open)
      }}
      getPopupContainer={() =>
        document.getElementById('lmsPage') as HTMLElement
      }
      onSelect={onSelect}
      onDeselect={onDeselect}
      notFoundContent={notFoundContent}
      disabled={disabled}
      filterOption={(input, option) =>
        (option.props.label as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      {...(rest as any)}
    >
      {children}
    </AntSelect>
  )
}

export default Select
